import { render, staticRenderFns } from "./AlgorithmicSection.vue?vue&type=template&id=1fb941b6&scoped=true&"
import script from "./AlgorithmicSection.vue?vue&type=script&lang=js&"
export * from "./AlgorithmicSection.vue?vue&type=script&lang=js&"
import style0 from "./AlgorithmicSection.vue?vue&type=style&index=0&id=1fb941b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb941b6",
  null
  
)

export default component.exports